import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import MainView from 'features/main/MainView'
import RegionRouterStore, { RegionRouterStoreProvider } from './RegionRouterStore'
import useStore from 'reusable/mobx-store-utils'
import { RegionAppPath } from '@gap/utils/region-utils'
import variables from 'variables/variables'

export default observer(function RegionRouter() {
   return (
      <BrowserRouter>
         <RegionRoutes />
      </BrowserRouter>
   )
})

const RegionRoutes = observer(function RegionRoutes() {
   const location = useLocation()
   const navigate = useNavigate()
   const regionRouterStore = useStore(sp => new RegionRouterStore(sp), { navigate, location })

   const regionRoutePaths = Object.values(RegionAppPath)

   const searchParams = window.location.search
   const urlParams = new URLSearchParams(searchParams)

   // Handle OAuth redirect regardless of current path (but not if already on oauth-redirect page)
   if (urlParams.get('oauth_redirect') === 'true' && !window.location.pathname.includes('/oauth-redirect')) {
      const userRegion = regionRouterStore.region || 'au'
      window.location.href = `${window.location.origin}/${userRegion}/oauth-redirect${searchParams}`
      return
   }

   // For production environments, CloudFront RegionRedirector handles region detection and redirect
   if (variables.stage.match(/^(dev|preview|feature|bug|rc)-.*$/) && !variables.isMultiRegion && ['/', '/trial'].includes(window.location.pathname)) {
      window.location.pathname = `/au${window.location.pathname}`
   }

   return (
      <RegionRouterStoreProvider store={regionRouterStore}>
         <Routes>
            {regionRoutePaths.map(path => (
               <Route path={path + '/*'} element={<MainView />} key={`region-route-${path}`} />
            ))}
         </Routes>
      </RegionRouterStoreProvider>
   )
})
